'use client';

import { formatDateTime } from '@pickleballinc/lib/format-dates';
import {
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
  DropdownTrigger,
} from '@pickleballinc/uiv2/components/dropdown';

import { TickerActivityRecord } from '@/modules/ticker/types';

interface TickerSummaryProps {
  activeTickers: TickerActivityRecord[];
  selectedIndex: number;
  onTickerSelect: (index: number) => void;
}

export const TickerSummary = ({
  activeTickers,
  selectedIndex,
  onTickerSelect,
}: TickerSummaryProps) => {
  const date = new Date().toISOString();
  const selectedTicker = activeTickers[selectedIndex];

  const handleSelect = (id: string) => {
    const index = activeTickers.findIndex(
      (ticker) => `${ticker.type}-${ticker.partnersFlag}` === id
    );
    if (index !== -1 && index !== selectedIndex) {
      onTickerSelect(index);
    }
  };

  return (
    <div className='flex w-24 shrink-0 flex-col divide-y divide-gray-300 border-x border-gray-300 bg-white sm:w-28'>
      {activeTickers.length > 1 ? (
        <div className='w-full px-1 py-2'>
          <Dropdown onSelect={handleSelect} size='sm' className='!block w-full'>
            <DropdownTrigger className='w-full text-center text-sm font-semibold !min-h-0 !px-1 !py-1'>
              {selectedTicker?.label || ''}
            </DropdownTrigger>
            <DropdownMenu>
              {activeTickers.map((ticker) => (
                <DropdownMenuItem
                  key={`${ticker.type}-${ticker.partnersFlag}`}
                  id={`${ticker.type}-${ticker.partnersFlag}`}
                >
                  <span className='text-sm uppercase font-semibold'>{ticker.label}</span>
                </DropdownMenuItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      ) : selectedTicker ? (
        <div className='w-full text-center text-lg font-semibold py-4'>{selectedTicker.label}</div>
      ) : null}
      <div className='flex flex-1 flex-col items-center justify-center py-2 text-center'>
        <span className='text-xs uppercase leading-5 tracking-wider text-gray-600'>
          {formatDateTime(date, { part: 'month' })}
        </span>
        <span className='text-xl font-bold uppercase tracking-wider text-black'>
          {formatDateTime(date, { part: 'day' })}
        </span>
      </div>
    </div>
  );
};
